import HTTPClient from "./http-client";

const options = {
  cache: {
    maxAge: 5 * 60 * 1000,
    exclude: { query: false },
  },
};

const loadRulerImageInfo = async (period, stationId = "25484909") => {
  try {
    if (period == undefined) {
      period = "latest"
    }
    const apiUrl = `/monitoring-sanepar/${stationId}_${period}.json`;

    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const response = await api.get(
      apiUrl,
      options
    );

    return response;
  } catch (error) {
    console.error("Erro ao buscar dados da imagem da régua:", error);
    throw error;
  }
};

const getRulerImageUrl = (period = "latest", stationId = "25484909") => {
  return `/riak/monitoring-sanepar/${stationId}_${period}.png`;
};

export { loadRulerImageInfo, getRulerImageUrl };
